import { ICategory } from '@collections/categories/interfaces/category.interface';
import { Pipe, PipeTransform } from '@angular/core';
import { RoutesService } from '@shared/services/routes/route.service';

@Pipe({
    name: 'getCategoryUrl',
    standalone: true
})
export class GetCategoryUrlPipe implements PipeTransform {

  constructor(private routesService: RoutesService) {

  }

  transform(category: ICategory, args?: any): any {
    return this.routesService.getCategoryUrl(category.path);
  }

}
